var map = {
	"./decidim/avatar-multiuser.png": 39187,
	"./decidim/brands/google.svg": 19794,
	"./decidim/cc-badge.png": 49201,
	"./decidim/decidim-logo.svg": 23009,
	"./decidim/default-avatar.svg": 36769,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 39575,
	"./decidim/icons.svg": 544,
	"./decidim/pattern.png": 35107,
	"./decidim/placeholder-card-g.svg": 58272,
	"./decidim/placeholder-card-l.svg": 23595,
	"./decidim/placeholder.jpg": 13122,
	"./decidim/remixicon.symbol.svg": 55992,
	"./decidim/vendor/leaflet/layers-2x.png": 51121,
	"./decidim/vendor/leaflet/layers.png": 16760,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 49161,
	"./decidim/vendor/leaflet/marker-icon.png": 36768,
	"./decidim/vendor/leaflet/marker-shadow.png": 12991,
	"./decidim/vendor/social-share-button/douban.svg": 13003,
	"./decidim/vendor/social-share-button/email.svg": 38692,
	"./decidim/vendor/social-share-button/facebook.svg": 24544,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 46836,
	"./decidim/vendor/social-share-button/hacker_news.svg": 9128,
	"./decidim/vendor/social-share-button/linkedin.svg": 11234,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 55531,
	"./decidim/vendor/social-share-button/pinterest.svg": 38818,
	"./decidim/vendor/social-share-button/reddit.svg": 7544,
	"./decidim/vendor/social-share-button/telegram.svg": 5869,
	"./decidim/vendor/social-share-button/tumblr.svg": 53418,
	"./decidim/vendor/social-share-button/twitter.svg": 20929,
	"./decidim/vendor/social-share-button/vkontakte.svg": 61355,
	"./decidim/vendor/social-share-button/wechat.svg": 88246,
	"./decidim/vendor/social-share-button/whatsapp.svg": 81998,
	"./decidim/vendor/social-share-button/x.svg": 15516,
	"./decidim/vendor/social-share-button/xing.svg": 54012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48654;